import { Stack, Typography } from '@mui/material';
import { Panel } from './Panel';
import { BlinkingCursor } from './BlinkingCursor';
import { CliBox } from './CliBox';

export function SystemErrorPanel({
  code = 'ERR_UNIMPLEMENTED',
  title = 'MODULE NOT AVAILABLE',
  description = 'The requested system module has not been initialized.',
}: {
  code?: string;
  title?: string;
  description?: string;
}) {
  return (
    <Panel>
      {/* Context */}
      <Typography
        variant="overline"
        sx={{
          color: 'secondary.main',
          letterSpacing: '0.15em',
        }}
      >
        SYSTEM ERROR
      </Typography>
      {/* Error code — strongest anchor */}
      <Typography
        variant="h4"
        sx={{ color: 'error.main', lineHeight: 1, mb: 2 }}
      >
        {code}
      </Typography>
      <CliBox>
        <Stack spacing={1}>
          {/* Primary message */}
          <Typography variant="subtitle1">{title}</Typography>

          {/* Secondary detail */}
          {description && (
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {description}
            </Typography>
          )}

          {/* Prompt */}
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            &gt; press escape to return
            <BlinkingCursor />
          </Typography>
        </Stack>
      </CliBox>
    </Panel>
  );
}
